import { Box } from '@wix/design-system';
import React from 'react';
import { useA11yWizardAdapter } from '../../../../hooks/use-a11y-wizard-adapter';
import { useSessionInfoContext } from '../../../../hooks/use-session-info-context';
import { dataHooks } from '../../../../utils/datahooks';
import { getFixerDesignPropsFromCapabilities } from '../../../../utils/get-fixer-design-props';
import { ColorContrastElementGenericContent } from './generic/color-contrast-element-generic-content';
import { ColorContrastIncompleteElementContent } from './incomplete/color-contrast-incomplete-element-content';
import { ColorContrastElementRegularContent } from './regular/color-contrast-element-regular-content';
export const ColorContrastElementContent = _ref => {
  var _designProps$ruleLayo;
  let {
    failedElement,
    onClickCancel,
    onClickApply,
    onChangeElementsColor,
    showLoader,
    elementIndex,
    status,
    isGeneric,
    pageId,
    dataHook
  } = _ref;
  const {
    locale
  } = useSessionInfoContext();
  const {
    capabilities
  } = useA11yWizardAdapter();
  const designProps = getFixerDesignPropsFromCapabilities(capabilities);
  const {
    minimalRatio,
    isIncomplete
  } = failedElement;
  const contentGap = ((_designProps$ruleLayo = designProps.ruleLayout) == null ? void 0 : _designProps$ruleLayo.gap) ?? 'SP3';
  const outerGap = capabilities.compactPanelChrome ? 'SP4' : 'SP2';
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: outerGap,
    width: "100%"
  }, /*#__PURE__*/React.createElement(Box, {
    dataHook: dataHooks.colorContrastElementContent(dataHook),
    direction: "vertical",
    gap: contentGap,
    padding: capabilities.compactPanelChrome ? '0 SP1' : '0'
  }, isIncomplete ? /*#__PURE__*/React.createElement(ColorContrastIncompleteElementContent, {
    elementIndex: elementIndex,
    failedElement: failedElement,
    locale: locale,
    minimalRatio: minimalRatio,
    pageId: pageId,
    showLoader: showLoader,
    status: status,
    onClickApply: onClickApply,
    onClickCancel: onClickCancel
  }) : isGeneric ? /*#__PURE__*/React.createElement(ColorContrastElementGenericContent, {
    elementIndex: elementIndex,
    failedElement: failedElement,
    locale: locale,
    minimalRatio: minimalRatio,
    pageId: pageId,
    showLoader: showLoader,
    status: status,
    onClickApply: onClickApply,
    onClickCancel: onClickCancel
  }) : /*#__PURE__*/React.createElement(ColorContrastElementRegularContent, {
    elementIndex: elementIndex,
    failedElement: failedElement,
    locale: locale,
    minimalRatio: minimalRatio,
    pageId: pageId,
    showLoader: showLoader,
    status: status,
    onChangeElementsColor: onChangeElementsColor,
    onClickApply: onClickApply,
    onClickCancel: onClickCancel
  })));
};
//# sourceMappingURL=color-contrast-element-content.js.map